var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWhitePoints(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.7505,
    cy: 12,
    r: 12,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_2188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.3719 12.3505L19.3778 12.3573V12.0721V6.92202L16.4937 5V12.029H16.4927C16.4928 12.0433 16.4937 12.0575 16.4937 12.0718C16.4937 14.275 14.7309 16.0674 12.5642 16.0674C10.3974 16.0674 8.6346 14.275 8.6346 12.0718C8.6346 9.86865 10.3974 8.07621 12.5642 8.07621C13.8302 8.07621 14.9576 8.68876 15.6768 9.63705V5.90729C14.7438 5.41923 13.6856 5.14363 12.5642 5.14363C8.80106 5.14363 5.75049 8.24551 5.75049 12.0718C5.75049 15.8982 8.80106 19 12.5642 19C16.2354 19 19.228 16.0476 19.3719 12.3505Z",
    fill: "#004236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7363 14.8832C19.7013 14.9689 19.6598 15.0509 19.6278 15.1359C18.9757 16.8734 17.4553 18.2968 16.2971 18.8467C16.3038 18.8516 19.7505 18.8558 19.7505 18.8558C19.7505 18.8558 19.7365 14.8932 19.7363 14.8832Z",
    fill: "#004236"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_2188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5.75049 5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitePoints);
export default __webpack_public_path__ + "static/media/white-points.f723f9fba43f4c8b2065511ae735f4f4.svg";
export { ForwardRef as ReactComponent };